import { useNavigate } from "react-router";
import { ago } from "../lib/format.ts";
import type { Project, Session } from "../lib/types.ts";
import { StatePill, useNow } from "./ui.tsx";

export function SessionsTable({ sessions, projects }: { sessions: Session[]; projects?: Project[] }) {
  const navigate = useNavigate();
  const now = useNow(30_000);
  const byId = new Map(projects?.map((p) => [p.id, p]));
  return (
    <div className="tablewrap">
      <table className="table">
        <thead>
          <tr>
            <th>Session</th>
            {projects && <th>Project</th>}
            <th>State</th>
            <th>Model</th>
            <th>Branch</th>
            <th>Last activity</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((s) => {
            const p = byId.get(s.projectId);
            return (
              <tr key={s.id} className="click" onClick={() => navigate(`/sessions/${s.id}`)}>
                <td>
                  <b>{s.name}</b>
                  {s.live && s.live.queued > 0 && <span className="muted small"> · {s.live.queued} queued</span>}
                </td>
                {projects && <td className="muted">{p?.slug ?? "—"}</td>}
                <td>
                  <StatePill state={s.state} reason={s.stateReason} />
                </td>
                <td className="mono small">{s.model ?? p?.defaultModel ?? "default"}</td>
                <td className="mono small muted">{s.branch}</td>
                <td className="muted small nowrap">{ago(s.lastEventAt ?? s.createdAt, now)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
